module.exports = __webpack_public_path__ + "static/img/4.783f731a.png";